import { gql } from "@apollo/client";

export const CREATE_REPORT = gql`
  mutation CreateReportMutation($input: CreateReportInput!) {
    createReport(input: $input) {
      ok
      error
      id
    }
  }
`;

export const UPDATE_REPORT = gql`
  mutation UpdateReportMutation($id: Int!, $input: UpdateReportInput!) {
    updateReport(id: $id, input: $input) {
      ok
      error
    }
  }
`;

export const REMOVE_REPORT = gql`
  mutation RemoveReportMutation($id: Int!) {
    removeReport(id: $id) {
      ok
      error
    }
  }
`;

export const REPORT = gql`
  query ReportQuery($id: Int!) {
    report(id: $id) {
      ok
      error
      result {
        id
        customerId
        weekStartDate
        content
        customer {
          id
          name
        }
      }
    }
  }
`;

export const REPORTS = gql`
  query ReportsQuery($where: ReportsFiltersInput!) {
    reports(where: $where) {
      ok
      error
      total
      results {
        id
        customerId
        weekStartDate
        content
        customer {
          id
          name
        }
      }
    }
  }
`;
